import { render, staticRenderFns } from "./render1.vue?vue&type=template&id=9a97f672"
import script from "./render1.vue?vue&type=script&lang=js"
export * from "./render1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports